
import { isEmpty } from "../gui_components/Util.js";
import {ServiceExecutorProxy}from "./ServiceExecutorProxy.js";
export class SecurityService {
  constructor() {}
  static initService(appData) {
    this.sessionBean = JSON.parse(localStorage.getItem("session"));
    this.companyCode = appData.companyCode;
    this.sec_data_url =
      appData.serviceURL + `/${process.env.REACT_APP_SECURITY_SERVICE_PATH}`;
    localStorage.setItem("security_token", this.sessionBean.securityPass);
  }
  static getRolePageList(input, responseCallBack, errorCallBack) {
    this.method("getRolePageList", input, responseCallBack, errorCallBack);
  }
  static getUserRolePageList(input, responseCallBack, errorCallBack) {
    this.method("getUserRolePageList", input, responseCallBack, errorCallBack);
  }
  static getModuleGroups(input, responseCallBack, errorCallBack) {
    this.method("getModuleGroups", input, responseCallBack, errorCallBack);
  }
  static getAccessibleEntitlements(input, responseCallBack, errorCallBack) {
    this.method(
      "getAccessibleEntitlements",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readRoleModuleDependencies(input, responseCallBack, errorCallBack) {
    this.method(
      "readRoleModuleDependencies",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createRole(input, responseCallBack, errorCallBack) {
    this.method("createRole", input, responseCallBack, errorCallBack);
  }
  static updateRole(input, responseCallBack, errorCallBack) {
    this.method("updateRole", input, responseCallBack, errorCallBack);
  }
  static initRoleModule(input, responseCallBack, errorCallBack) {
    this.method("initRoleModule", input, responseCallBack, errorCallBack);
  }
  static getRolePageList(input, responseCallBack, errorCallBack) {
    this.method("getRolePageList", input, responseCallBack, errorCallBack);
  }
  static unLockRoleCode(input, responseCallBack, errorCallBack) {
    this.method("unLockRoleCode", input, responseCallBack, errorCallBack);
  }
  static readRole(input, responseCallBack, errorCallBack) {
    this.method("readRole", input, responseCallBack, errorCallBack);
  }
  
  
  static method(methodName, input, responseCallBack, errorCallBack) {
    if (isEmpty(this.sessionBean)) {
    } else if (isEmpty(this.sessionBean.securityPass)) {
    } else {
      // const isFormData = input instanceof FormData;
      // axios({
      //   method: "post",
      //   url: this.sec_data_url + "/" + methodName,
      //   data: input,
      //   headers: {
      //     securitykey: localStorage.getItem("security_token"),
      //     Accept: "application/json",
      //     //"Content-Type": "application/json",
      //     ...(isFormData ? {} : { "Content-Type": "application/json" }),
      //   },
      // })
      //   .then((response) => {
      //     responseCallBack(response);
      //   })
      //   .catch((error) => {
      //     errorCallBack(error);
      //     ShowError("Erro : " + error);
      //   });
      ServiceExecutorProxy.executeService(methodName, input,this.sec_data_url,responseCallBack, errorCallBack);
    }
  }
}
